import insightReducer from './slice';

export default insightReducer;

export * from './consts';
export * from './data';
export * from './selectors';
export * from './slice';
